/**
 * Cache for assignee data to avoid redundant API calls.
 */

// Cache for project members: { [projectId]: { members: [], loginToObjId: {}, nameMap: {} } }
const projectMembersCache = {};

// Cache for global system users: { users: [], nameMap: {} }
let globalUsersCache = null;

/**
 * Gets cached project members for a specific project.
 * @param {string} projectId 
 * @returns {Object|null}
 */
export const getCachedProjectMembers = (projectId) => {
  return projectMembersCache[projectId] || null;
};

/**
 * Sets cached project members for a specific project.
 * @param {string} projectId 
 * @param {Object} data 
 */
export const setCachedProjectMembers = (projectId, data) => {
  projectMembersCache[projectId] = data;
};

/**
 * Gets cached global system users.
 * @returns {Object|null}
 */
export const getCachedGlobalUsers = () => {
  return globalUsersCache;
};

/**
 * Sets cached global system users.
 * @param {Object} data 
 */
export const setCachedGlobalUsers = (data) => {
  globalUsersCache = data;
};

/**
 * Clears all assignee caches.
 */
export const clearAssigneeCache = () => {
  Object.keys(projectMembersCache).forEach(key => delete projectMembersCache[key]);
  globalUsersCache = null;
};
